import { makeStyles } from 'tss-react/mui';
import { theme } from '../../../theme';

/**
 * Custom hook that defines the styles for the form component.
 */
const useFormStyles = makeStyles()(() => ({
  form: {
    backgroundColor: theme.background.paper,
    boxShadow: theme.containerShadow,
    borderRadius: theme.borderRadius.s,
    padding: theme.padding.m,
    width: '60%',
    margin: '20px auto',
  },
}));

export default useFormStyles;
